<template>
  <div class="workbench">
    <img v-if="ad" :src="ad" alt="ad" style="width: 100%; display: block; margin-bottom: 14px;">
    <div style="display: flex;justify-content: space-between">
      <UserCard></UserCard>
      <CapitalCard></CapitalCard>
    </div>
    <OrderCard></OrderCard>

    <orderItem
      :order_no="item.number"
      :product_img="item.product_img"
      :status_name="item.status_name"
      :created_at="item.created_at"
      :phone="item.phone"
      :address="item.address"
      :contact="item.contact"
      :customer_name="getCustomerName(item)"

      :service_name="item.service_name"
      :product_class="item.product_class"
      :product_number="item.product_number"
      :order_type="item.order_type"
      :price="item.price"
      :show_offer="getShowOffer(item)"
      :fee_detail="item.fee_detail"
      :remark="item.remark || ''"
      :remark_list="item.remark_list || item.remarks || item.order_remarks || []"
      :remark_count="getRemarkCount(item)"
      :flag_color="item.flag_color || item.remark_color || item.color || ''"
      :has_worker_inscrease="item.has_worker_inscrease"
      :order_inscrease="item.order_inscrease"
      :status="item.status"
      :id="item.id"
      @refresh="getOrder"
      v-for="(item,i) in orderData"
      :key="i"></orderItem>

  </div>
</template>

<script>
import UserCard from './components/userCard'
import OrderCard from './components/order/order'
import CapitalCard from './components/capital/capital'
import orderItem from '../order/components/order-item'
export default {
  components: { UserCard, OrderCard, CapitalCard, orderItem },
  name: 'workbench',
  data () {
    return {
      orderData: [],
      ad: '',
      orderRequestKey: 0,
      remarkCache: {}
    }
  },
  created () {
    let vm = this
    this.$request('61cbbdb6af43a', {
      edition_number: '1'
    }).then(res => {
      const ad = res.data.data && res.data.data.ad
      vm.ad = typeof ad === 'string' ? ad.trim() : (ad || '')
    })
    vm.getOrder()
  },
  methods: {
    getShowOffer (order) {
      const offer = Array.isArray(order.offer_info) ? order.offer_info[0] : null
      if (offer && offer.show_offer !== undefined && offer.show_offer !== null && offer.show_offer !== '') {
        return offer.show_offer
      }
      return 0
    },
    getCustomerName (order) {
      if (!order) return ''
      const address = order.address && typeof order.address === 'object' ? order.address : {}
      const names = [order.customer_name, address.name, order.name, order.contacts_name, order.customer]
      return names.find(name => typeof name === 'string' && name.trim()) || ''
    },
    getRemarkCount (order) {
      if (!order) return 0
      return Number(order.tag_count || order.remark_count || order.remarks_count || order.order_remark_count || 0)
    },
    mergeOrderRemark (order) {
      const cached = this.remarkCache[order.id]
      if (!cached) return order
      return Object.assign({}, order, {
        remark_list: cached.list,
        remark_count: cached.total,
        flag_color: cached.list[0] ? cached.list[0].color : (order.flag_color || order.remark_color || order.color || '')
      })
    },
    getOrderRemark (order) {
      return this.$request('690000000002', { order_id: order.id, page: 1 }).then(res => {
        const data = res.data.data || []
        const list = Array.isArray(data) ? data : (data.list || data.data || data.rows || [])
        const total = Array.isArray(data) ? list.length : (data.total || data.count || data.listCount || data.list_count || list.length)
        return {
          list: list.map(item => ({
            content: item.remark || item.remarks || item.content || item.note || item.text || '',
            color: item.color || item.flag_color || item.remark_color || '#ff4d4f',
            id: item.id,
            remark_id: item.remark_id,
            created_at: item.created_at,
            create_time: item.create_time,
            created_time: item.created_time,
            add_time: item.add_time,
            updated_at: item.updated_at,
            update_time: item.update_time
          })).filter(item => item.content),
          total: Number(total) || list.length
        }
      }).catch(() => ({ list: [], total: 0 }))
    },
    loadOrderRemarks (orders, requestKey) {
      orders.forEach(order => {
        this.getOrderRemark(order).then(data => {
          if (requestKey !== this.orderRequestKey) return
          this.$set(this.remarkCache, order.id, data)
          const index = this.orderData.findIndex(item => String(item.id) === String(order.id))
          if (index !== -1) {
            this.$set(this.orderData, index, Object.assign({}, this.orderData[index], {
              remark_list: data.list,
              remark_count: data.total,
              flag_color: data.list[0] ? data.list[0].color : (order.flag_color || order.remark_color || order.color || '')
            }))
          }
        })
      })
    },
    async loadOrderDetails (orders, requestKey) {
      for (const order of orders) {
        if (requestKey !== this.orderRequestKey) return
        const needsFeeDetails = !Array.isArray(order.order_inscrease) &&
          (String(order.has_worker_inscrease) === '1' || order.has_worker_inscrease === true)
        if (!order.id || (this.getCustomerName(order) && !needsFeeDetails)) continue
        try {
          const res = await this.$request('6120ad9af2b9b', { order_id: order.id }, 'post', { silentError: true })
          if (requestKey !== this.orderRequestKey) return
          const detail = res && res.data && res.data.data
          const item = this.orderData.find(item => String(item.id) === String(order.id))
          if (!item) continue
          const name = detail && detail.address && detail.address.name
          if (typeof name === 'string' && name.trim()) this.$set(item, 'customer_name', name.trim())
          if (detail && Array.isArray(detail.order_inscrease)) this.$set(item, 'order_inscrease', detail.order_inscrease)
        } catch (error) {
          // Details are supplementary; keep the order row visible if this request fails.
        }
      }
    },
    getOrder () {
      const requestKey = ++this.orderRequestKey
      return this.$request('6182826d5d0aa', {
        page: 1,
        limit: 10,
        status: '',
        class_id: 0,
        type_id: 0,
        worker_nickname: '',
        worker_phone: '',
        contacts: '',
        order_no: ''
        // type:vm.searFrom.type.toString(),
        // start_time:vm.searFrom.start_time,
        // end_time:vm.searFrom.end_time
      }).then(res => {
        if (requestKey !== this.orderRequestKey) return
        const orders = Array.isArray(res.data.data) ? res.data.data : []
        this.orderData = orders.map(order => this.mergeOrderRemark(order))
        this.loadOrderRemarks(orders, requestKey)
        this.loadOrderDetails(orders, requestKey)
      })
    }
  }
}
</script>

<style scoped lang="less">
.workbench {
  padding: 10px;

}
</style>
